declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { HCPService } from '../../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest, EmergencyContactInfoController, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { ActorImageController } from '../../../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { NgbEditEmergencyModal } from '../personaldetailview/modal/editemergency.modal';
import { NgbAddEmergencyModal } from '../personaldetailview/modal/addemergency.modal';


@Component({
  selector: 'emergencyinfoview',
  templateUrl: './emergencyview.component.html',
  styleUrls: ['./emergencyview.component.scss']
})

export class EmergencyViewComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  public isRequesting: boolean = false;
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

  ValueChangeActorImageController: ActorImageController;

  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();

  DOB: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalDetailInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //
  public onInput(value: Date): void {

    console.log('value-->' + value);

    this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = value;
  }
  CurrentEmergencyContactInfoController: EmergencyContactInfoController[];
  CurrentEmergencyContactInfoRequest: EmergencyContactInfoRequest;
  CurrentActorEditEmergencyInfoRequest: EmergencyContactInfoRequest;
  LoadPatients() {
    this.CurrentEmergencyContactInfoRequest = new EmergencyContactInfoRequest();
    this.CurrentEmergencyContactInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentEmergencyContactInfoRequest.AddressLine1 = "";
    //this.CurrentEmergencyContactInfoRequest.AddressLine2 = "";
    //this.CurrentEmergencyContactInfoRequest.EmergencyAddress = "";
    //this.CurrentEmergencyContactInfoRequest.EmergencyContactNo1 = "";
    //this.CurrentEmergencyContactInfoRequest.EmergencyContactNo2 = "";
    //this.CurrentEmergencyContactInfoRequest.EmergencyContactPersonName = "";
    //this.CurrentEmergencyContactInfoRequest.RelationType = "";
    this.CurrentEmergencyContactInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetEmergencyContactInfoController();
  }
  SelectedPatientEmergencyDetails: EmergencyContactInfoController;
  GetEmergencyContactInfoController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.hcpservice.GetEmergencyContactInfoController(this.CurrentEmergencyContactInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentEmergencyContactInfoController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          this.SelectedPatientEmergencyDetails = this.CurrentEmergencyContactInfoController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {
    this.LoadPatients();
    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: 1900, month: 1, day: 1 };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentActorEditEmergencyInfoRequest = new ActorContactInfoRequest();
    this.CurrentActorEditEmergencyInfoRequest = new EmergencyContactInfoRequest();
    //this.CurrentActorEditEmergencyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEditEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ValueChangeActorImageController = new ActorImageController();
    if (this.CanShow === 1) {
      this.GetActorPersonalDetailInfoController();
    }

  }

  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorPersonalDetailInfoController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }
  AddEmergencyDetails() {




    const modalRef = this.modalService.open(NgbAddEmergencyModal,
      {
        centered: true

      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  edit(l: EmergencyContactInfoController) {

    this.CurrentActorEditEmergencyInfoRequest.ActorCode = l.ActorCode;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyContactCode = l.EmergencyContactCode;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyAddress = l.EmergencyAddress;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyContactPersonName = l.EmergencyContactPersonName;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyContactNo1 = l.EmergencyContactNo1;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyContactNo2 = l.EmergencyContactNo2;
    this.CurrentActorEditEmergencyInfoRequest.RelationType = l.RelationType;
    this.CurrentActorEditEmergencyInfoRequest.EmergencyAddress = l.EmergencyAddress;



    const modalRef = this.modalService.open(NgbEditEmergencyModal,
      {
        centered: true

      })
    modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
    modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  onSubmit() {

    this.StartRefreshing();

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.customdatetimeservice.converToLocalTime(this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //}
    // console.log('this.DOB--->' + this.DOB);
    if (this.DOB != null) {



      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));;

      // console.log('this.DateOfBirth--->' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth );
    }
    this.hcpservice.SaveActorPersonalDetailInfo(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorPersonalDetailInfoController();

            // alertFunctions.AlertParam('Saved Successfully.....!');

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  //ngAfterViewInit() {
  //  //pSteps.loadStep();
  //}
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData.Result[0];

          this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
          this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
          this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
          this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
          this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
          this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
          this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;



          if (this.CurrentActorPersonalDetailInfoController.DateOfBirth != null) {

            var SDOB = new Date(this.CurrentActorPersonalDetailInfoController.DateOfBirth);
            ;
            if (SDOB.getFullYear() > 1900) {

              this.DOB = {

                year: SDOB.getFullYear(),
                month: SDOB.getMonth() + 1,
                day: SDOB.getDate()
              }
            }
            else {
              this.DOB = {

                year: 1900,
                month: 1,
                day: 1
              }
            }
          }
          this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
          this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
          this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
          this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
          this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
          this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
          this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
          this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
          this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
          //
          //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
          this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
          this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
          this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA"
          //this.CurrentActorPersonalDetailInfoController.Country;
          this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
          this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
          this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
          this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
          this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;
          this.CurrentActorPersonalDetailInfoRequest.Zip = this.CurrentActorPersonalDetailInfoController.Zip;
          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          //this.key = this.ApiResData.Result[0];

          //this.personalInfoChange.emit(this.key);
          // console.log('this.personalInfoChange' + this.key.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
      this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
      this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
      this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
      this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
      this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
      this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
      this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
      this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
      this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
      this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
      this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
      this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
      this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
      //
      //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
      this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
      this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
      this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA";
      //this.CurrentActorPersonalDetailInfoController.Country;
      this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
      this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
      this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
      this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
      this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;

      //
      this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
      this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }


}
